import type { ErrorContext } from '@/libs/datadog';

/**
 * Display name reported to the topbar micro-frontend, both for the product logo
 * and as the app identity behind the Cookie Consent banner.
 */
export const PANORAMA_APP_NAME = 'Panorama';

/**
 * Datadog context attached when the remote `topbar-navigation` micro-frontend
 * fails to load and the boundary degrades to <TopbarFallback/>. Keeps the
 * failure filterable/alertable in RUM by `feature`.
 */
export const TOPBAR_ERROR_CONTEXT: ErrorContext = {
  feature: 'topbar-navigation',
  degraded: true
};
